import { render, staticRenderFns } from "./AppContactsCustomFields.vue?vue&type=template&id=40bed774&scoped=true"
import script from "./AppContactsCustomFields.vue?vue&type=script&lang=js"
export * from "./AppContactsCustomFields.vue?vue&type=script&lang=js"
import style0 from "./AppContactsCustomFields.vue?vue&type=style&index=0&id=40bed774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bed774",
  null
  
)

export default component.exports